import { driveFileIdFrom } from '../reviewPortal/reviewLens';

/**
 * The artwork file itself, not its thumbnail.
 *
 * Kyu: "supplier need the approved designs, otherwise how will they know what
 * to work on?" — and again, of the PO preview: "it doesn't attach the high res
 * files approved by the client."
 *
 * A Drive share URL opens a viewer page, and the <img> beside this shows
 * Drive's w1600 preview — enough to recognise a component, not enough to
 * manufacture from. uc?export=download returns the ACTUAL bytes for the same
 * file id: the original the client approved, at whatever resolution it was
 * uploaded.
 *
 * When the URL carries no recognisable id — a direct googleusercontent link,
 * say — the link opens the file instead, which still reaches a Download
 * button. Falling back to the share URL beats rendering nothing.
 *
 * Marked po-no-print because it belongs to the screen. On paper a line reading
 * "Download Charm" is a dead instruction, and the sheet is already dense.
 */
export function ArtworkDownload({ url, component }: { url: string; component: string }) {
  const fileId = driveFileIdFrom(url);
  const href =
    fileId === null
      ? url
      : `https://drive.google.com/uc?export=download&id=${encodeURIComponent(fileId)}`;
  return (
    <a
      className="job-order-proof-download po-no-print"
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      download
    >
      {fileId === null ? `Open ${component} ↗` : `Download ${component}`}
    </a>
  );
}
